/**
 *
 * DocumentsOverviewColumn
 *
 */

import React from 'react';
import { Link } from 'react-router-dom';

// import clsx from 'clsx';
import { DOCUMENTS_PAGE } from 'lib/routes';

// api
import { InvoiceContainerWithoutInvoiceDetections } from 'lib/api/invoiceContainer';

// decorate
import { decorate, Decorate } from './decorate';
import { FormattedMessage } from 'lib/intl';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export interface DocumentsOverviewColumnProps {
  document: InvoiceContainerWithoutInvoiceDetections;
  sizeFactor: number;
}

const DocumentsOverviewColumn: React.FC<DocumentsOverviewColumnProps & Decorate> = (props) => {
  const { classes, document } = props;

  function deriveStateName(documentState: any) {
    switch (documentState) {
      case 'needforaction':
        return <FormattedMessage id="DOCUMENTS_NEED_FOR_ACTION" />;
      case 'autoprocessed':
        return <FormattedMessage id="DOCUMENTS_AUTOPROCESSED" />;
      case 'new':
        return <FormattedMessage id="DOCUMENTS_NEW" />;
      case 'validated':
        return <FormattedMessage id="DOCUMENTS_VALIDATED" />;
      case 'released':
        return <FormattedMessage id="DOCUMENTS_RELEASED" />;
      case 'downloaded':
        return <FormattedMessage id="DOCUMENTS_DOWNLOADED" />;
      case 'deleted':
        return <FormattedMessage id="DOCUMENTS_DELETED" />;
      case 'confirmed':
        return <FormattedMessage id="DOCUMENTS_CONFIRMED" />;
      case 'error':
        return <FormattedMessage id="DOCUMENTS_ERROR" />;
    }
  }

  function convertDate(oldDate: any) {
    let myDate = new Date(Date.parse(oldDate)); //String -> Timestamp -> Date object
    let day = myDate.getDate(); //get day
    let month = myDate.getMonth() + 1; //get month
    let year = myDate.getFullYear(); //get Year (4 digits)
    let hours = myDate.getHours();
    let minutes = myDate.getMinutes();
    return pad(day,2) + "-" + pad(month, 2) + "-" + year + " " + pad(hours, 2) + ':' + pad(minutes, 2);
  }

  function pad(num: any, size: any) { //function for adding leading zeros
    let s = num + "";
    while (s.length < size) s = "0" + s;
    return s;
  }

  return (
    <Link
      to={`${DOCUMENTS_PAGE}/${document.ContainerId}`}
      className={classes.root}
    >
      <tr className={classes.details}>
        <td className={classes.detailItem}><span className={classes.ellipsisTextOverflow}>{document.CreatedBy}</span></td>
        <td className={classes.detailItem}>{convertDate(document.Created)}</td>
        <td className={classes.state}><p className={classes.stateText}>{deriveStateName(document.Invoices[0].InvoiceState.toLowerCase())}</p></td>
        <td 
          className={classes.detailItem}
          onClick={(e)=> {
            e.preventDefault();
            navigator.clipboard.writeText(document.ContainerId);
            toast.info('Copied Container ID', { 
              theme: 'light' , 
              position: 'bottom-center',
              autoClose: 3000 
            });
          }}
        >
        
          <div className={classes.middleEllipsisOverflowContainer}>
            <span className={classes.middleEllipsisOverflowLeft}>
              <div className={classes.middleEllipsisOverflowWrap}>
                {`${document.ContainerId.substring(0, 16)}`}
              </div>
            </span>
            <span className={classes.middleEllipsisOverflowRight}>
              <span className={classes.middleEllipsisOverflowDummyElement}>x</span><span className={classes.middleEllipsisOverflowRevertToLtr}>{`${document.ContainerId.substring(16, 36)}`}</span>
            </span>
          </div>
        </td>
      </tr>
    </Link>
  );
};

const StyledDocumentsOverviewColumns = decorate(DocumentsOverviewColumn);
export { StyledDocumentsOverviewColumns as DocumentsOverviewColumn };
